const LOCALE_STORAGE_KEY = "treel_selected_locale";

export class LocaleService {
  static getSelectedLocale(): string {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    return stored || "en-US";
  }

  static setSelectedLocale(locale: string): void {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  }

  static clearSelectedLocale(): void {
    localStorage.removeItem(LOCALE_STORAGE_KEY);
  }
}
